module.exports = __webpack_public_path__ + "RMR PKG & TRN Enrollment Guide.pdf";